import { SxProps, Theme } from "@mui/material/styles";
import { minHeight } from "@mui/system";

export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1,
        width: "100%",
        maxWidth: 1200,
        display: "grid",
        gridGap: "15px",
        justifyContent: "center",
        alignContent: "center",
        // height: "calc(100vh - (84px * 1) - 2px - 48px)",
        py: 2,
        gridTemplateColumns: "repeat( auto-fill, minmax(350px, 500px) )",
    };
}

export function card(theme: Theme): SxProps<Theme> {
    return {
        textAlign: "center",
        mx: "auto",
        minWidth: { xs: 200, sm: 275, md: 350 },
        maxWidth: { xs: 250, sm: 300, md: 400 },
        width: "100%",
        minHeight: "150px",
        display: "flex",
        flexDirection: "column",
    };
}
